/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_TitleInputs */

const en_changelog_title = /** @type {(inputs: Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crazy Frog AI Changelog`)
};

const es_changelog_title = /** @type {(inputs: Changelog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de cambios de Crazy Frog AI`)
};

/**
* | output |
* | --- |
* | "Crazy Frog AI Changelog" |
*
* @param {Changelog_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const changelog_title = /** @type {((inputs?: Changelog_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_changelog_title(inputs)
	return es_changelog_title(inputs)
});